var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "logintop" }, [
        _c("div", { staticClass: "logintopc" }, [
          _c("img", {
            staticClass: "logo",
            staticStyle: { width: "1.8rem" },
            attrs: { src: _vm.platformConfig.mini_logo, alt: "" },
          }),
          _vm._v(_vm._s(_vm.platformConfig.mini_name) + "后台管理系统\n\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cont " }, [
        _c(
          "div",
          { staticClass: "flex loginc" },
          [
            _c("div"),
            _vm._v(" "),
            _c(
              "el-row",
              {
                staticClass: "login-container flex-wrap",
                attrs: { type: "flex", align: "middle" },
              },
              [
                _c("div", { staticClass: "login-form" }, [
                  _c(
                    "div",
                    { staticClass: "title-container text-center rel" },
                    [
                      _c(
                        "el-tabs",
                        {
                          staticClass: "fs-a1",
                          attrs: { stretch: true },
                          model: {
                            value: _vm.loginType,
                            callback: function ($$v) {
                              _vm.loginType = $$v
                            },
                            expression: "loginType",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "密码登录", name: "1" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "loginForm",
                                  attrs: {
                                    model: _vm.loginForm,
                                    rules: _vm.loginRules,
                                    "label-position": "left",
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "mt-20 ",
                                      attrs: { prop: "username" },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          ref: "username",
                                          attrs: {
                                            type: "text",
                                            name: "username",
                                            tabindex: "1",
                                            autocomplete: "on",
                                            placeholder: "请输入用户名",
                                          },
                                          model: {
                                            value: _vm.loginForm.username,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.loginForm,
                                                "username",
                                                $$v
                                              )
                                            },
                                            expression: "loginForm.username",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "icon ",
                                            attrs: {
                                              slot: "prefix",
                                              src: require("../../../src/assets/user.png"),
                                              alt: "",
                                            },
                                            slot: "prefix",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "password mt-20" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "svg-container",
                                          attrs: { slot: "suffix" },
                                          slot: "suffix",
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: { "icon-class": "password" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          key: _vm.passwordType,
                                          ref: "password",
                                          attrs: {
                                            type: _vm.passwordType,
                                            name: "password",
                                            tabindex: "2",
                                            autocomplete: "on",
                                            placeholder: "请输入密码",
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.handleLogin($event)
                                            },
                                          },
                                          model: {
                                            value: _vm.loginForm.password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.loginForm,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression: "loginForm.password",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "icon ",
                                            attrs: {
                                              slot: "prefix",
                                              src: require("../../../src/assets/key.png"),
                                              alt: "",
                                            },
                                            slot: "prefix",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "show-pwd",
                                          on: { click: _vm.showPwd },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              "icon-class":
                                                _vm.passwordType === "password"
                                                  ? "eye"
                                                  : "eye-open",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "code" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              ref: "code",
                                              staticClass: "flex1",
                                              attrs: {
                                                type: "text",
                                                name: "code",
                                                tabindex: "3",
                                                autocomplete: "off",
                                                placeholder: "请输入验证码",
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.handleLogin($event)
                                                },
                                              },
                                              model: {
                                                value: _vm.loginForm.code,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.loginForm,
                                                    "code",
                                                    $$v
                                                  )
                                                },
                                                expression: "loginForm.code",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "icon ",
                                                attrs: {
                                                  slot: "prefix",
                                                  src: require("../../../src/assets/code.png"),
                                                  alt: "",
                                                },
                                                slot: "prefix",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass: "ml-10",
                                            attrs: { src: _vm.verifyUrl },
                                            on: {
                                              click: function ($event) {
                                                return _vm.refreshVerify()
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mt-20 login-btn",
                                      attrs: { loading: _vm.loading },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleLogin($event)
                                        },
                                      },
                                    },
                                    [_vm._v("登陆")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "验证码登录", name: "2" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "authForm",
                                  attrs: {
                                    model: _vm.authForm,
                                    rules: _vm.authRules,
                                    "label-position": "left",
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "mt-20 mb-20",
                                      attrs: { prop: "phone_num" },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          ref: "phone_num",
                                          attrs: {
                                            type: "text",
                                            name: "phone_num",
                                            tabindex: "1",
                                            autocomplete: "on",
                                            placeholder: "请输入手机号码",
                                          },
                                          model: {
                                            value: _vm.authForm.phone_num,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.authForm,
                                                "phone_num",
                                                $$v
                                              )
                                            },
                                            expression: "authForm.phone_num",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "icon ",
                                            attrs: {
                                              slot: "prefix",
                                              src: require("../../../src/assets/user.png"),
                                              alt: "",
                                            },
                                            slot: "prefix",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "captche_num" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              ref: "captche_num",
                                              staticClass: "flex1",
                                              attrs: {
                                                type: "text",
                                                name: "captche_num",
                                                tabindex: "1",
                                                autocomplete: "on",
                                                placeholder: "请输入手机验证码",
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.authLogin($event)
                                                },
                                              },
                                              model: {
                                                value: _vm.authForm.captche_num,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.authForm,
                                                    "captche_num",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "authForm.captche_num",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "icon ",
                                                attrs: {
                                                  slot: "prefix",
                                                  src: require("../../../src/assets/code.png"),
                                                  alt: "",
                                                },
                                                slot: "prefix",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("auth-code", {
                                            ref: "authCode",
                                            on: {
                                              authCode: function ($event) {
                                                return _vm.getAuthCode()
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mt-20 login-btn",
                                      attrs: { loading: _vm.loading },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.authLogin($event)
                                        },
                                      },
                                    },
                                    [_vm._v("登陆")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "foot text-center fs-s3 hidden-sm-and-down text-black",
          staticStyle: { opacity: ".75" },
        },
        [
          _c("a", [_vm._v(_vm._s(_vm.platformConfig.company_name))]),
          _vm._v(" "),
          _c("a", { staticClass: "ml-10" }, [
            _vm._v("地址：" + _vm._s(_vm.platformConfig.company_address)),
          ]),
          _vm._v(" "),
          _c("a", { staticClass: "ml-10" }, [
            _vm._v("客服电话：" + _vm._s(_vm.platformConfig.service_phone)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择项目",
            visible: _vm.showProjectSelector,
            width: "100%",
            fullscreen: true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            "custom-class": "full-screen-project-selector",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showProjectSelector = $event
            },
          },
        },
        [
          _c("div", { staticClass: "project-selector-container" }, [
            _c("div", { staticClass: "title-section" }, [
              _c(
                "h3",
                {
                  staticClass: "main-title",
                  on: { click: _vm.handleAdminClick },
                },
                [_vm._v("综合多项目登入口")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-section" }, [
              _c("div", { staticClass: "left-section" }, [
                _c("h2", { staticClass: "section-title" }, [
                  _vm._v("单项目登入口"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right-section" }, [
                _c(
                  "div",
                  { staticClass: "grid-container" },
                  _vm._l(_vm.gridItems, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "grid-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleItemClick(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.name) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }